import { defineMessages, type MessageDescriptor } from 'react-intl';

const messages: Record<'defaultAgentName' | 'closeLabel', MessageDescriptor> = defineMessages({
	defaultAgentName: {
		id: 'conversation-assistant-chat-prompt-input.chat-prompt-input.agent-input-hat-messages.defaultAgentName',
		defaultMessage: 'Rovo',
		description:
			'Default identity name shown in the active-agent hat above the Rovo Chat input when no specialist agent is selected.',
	},
	closeLabel: {
		id: 'conversation-assistant-chat-prompt-input.chat-prompt-input.agent-input-hat-messages.closeLabel',
		defaultMessage: 'Dismiss active agent',
		description:
			'Accessible label for the close button in the active-agent hat above the Rovo Chat input.',
	},
});

export default messages;
